import {
  InsuranceMonitor,
  InsuranceMonitorStatus
} from "@wingspanhq/wingspan-api-sdk";

import { StepItem } from "../../../../../../shared/components/Steps";

/**
 * v1 monitor statuses map onto v3 `InsuranceMonitorStatus`:
 * Complete (a coverage satisfied every requirement) → Compliant;
 * ForceMatched (a coverage was linked manually and failed validation, i.e. a
 * partial match under review) → NonCompliant; Pending/Monitoring stay at the
 * policy-match stage.
 */
export const getInsuranceCoverageProgressSteps = (
  insuranceMonitor: InsuranceMonitor | undefined
): StepItem[] => {
  switch (insuranceMonitor?.status) {
    case InsuranceMonitorStatus.FORCE_MATCHED:
      return [
        {
          title: "Policy match",
          status: "Warning"
        },
        {
          title: "Complete",
          status: "Pending"
        }
      ];
    case InsuranceMonitorStatus.COMPLETE:
      return [
        {
          title: "Policy match",
          status: "Complete"
        },
        {
          title: "Complete",
          status: "Complete"
        }
      ];
    default:
      return [
        {
          title: "Policy match",
          status: "Active"
        },
        {
          title: "Complete",
          status: "Pending"
        }
      ];
  }
};
